import React from 'react'
import { Grid } from '@material-ui/core'
import { SupportedBrowsersHelpIcon } from '../SupportedBrowsersHelpIcon'
import { hasEmptyInputs } from './helper'
import CompanyLogo from '../../../app/components/companyLogo'
import { LoginTitle, StyledButton } from '../../../theme/Global'
import {
  CustomErrorMessage,
  CustomFullPageWrapper,
  CustomPaper,
  StyledCircularProgress,
  ErrorMessageWrapper
} from './styles'

const AuthenticationForm = ({
  helpIconAnchorEl,
  setHelpIconAnchorEl,
  errorText,
  submitError,
  onCloseError,
  status,
  submit,
  title,
  inputComponents,
  message
}) => (
  <CustomFullPageWrapper>
    <Grid
      container
      justify="center"
      style={{
        width: '100%',
        margin: 0
      }}
    >
      <Grid item xs={12} lg={12}>
        <CustomPaper>
          <SupportedBrowsersHelpIcon setAnchorEl={setHelpIconAnchorEl} anchorEl={helpIconAnchorEl} />
          <Grid container spacing={24}>
            <Grid item xs={12}>
              <CompanyLogo size="login" color />
            </Grid>
            <Grid item xs={12}>
              <LoginTitle>{title}</LoginTitle>
              <ErrorMessageWrapper open={submitError} onClose={onCloseError}>
                <CustomErrorMessage className="error" data-testid="error-text">
                  <Grid container>
                    <Grid item xs={10}>
                      {errorText}
                    </Grid>
                    <Grid item xs={2}>
                      <StyledButton data-testid="close-error-button" onClick={() => onCloseError()}>Close</StyledButton>
                    </Grid>
                  </Grid>
                </CustomErrorMessage>
              </ErrorMessageWrapper>
            </Grid>
            {message
              ? (
                <Grid item xs={12}>
                  {message}
                </Grid>
              )
              : null}
            {inputComponents.map((input) => (
              <Grid item xs={12} key={input.props.name}>
                {input}
              </Grid>
            ))}
            <Grid item xs={12}>
              <Grid
                container
                spacing={24}
                direction="row"
                justify="flex-start"
                alignItems="center"
              >
                <Grid item>
                  <StyledButton data-testid="submit-button" disabled={status === 'attempting' || hasEmptyInputs(inputComponents)} onClick={submit}>
                    {status === 'attempting' ? <StyledCircularProgress size={16} /> : null}
                    Submit
                  </StyledButton>
                </Grid>
                <Grid
                  item
                  style={{ paddingLeft: '24px' }}
                />
              </Grid>
            </Grid>
          </Grid>
        </CustomPaper>
      </Grid>
    </Grid>
  </CustomFullPageWrapper>
)

export default AuthenticationForm
